module.exports = __webpack_public_path__ + "static/media/Hand Shake.964e7de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/Hand Shake.png
// module id = 209
// module chunks = 0